export interface SyncStatus {
  isOnline: boolean;
  isSyncing: boolean;
  lastAttemptAtUtc: string | null;
  lastSuccessAtUtc: string | null;
  /** Set when the most recent batch attempt failed outright (network/5xx); cleared on the next successful attempt. */
  lastError: string | null;
  /** Consecutive whole-batch failures -- drives the backoff multiplier; reset to 0 on any successful attempt. */
  consecutiveFailures: number;
}

export const INITIAL_SYNC_STATUS: SyncStatus = {
  isOnline: navigator.onLine,
  isSyncing: false,
  lastAttemptAtUtc: null,
  lastSuccessAtUtc: null,
  lastError: null,
  consecutiveFailures: 0
};
